<template>
  <div>
    <toolbar/>
    <div class="containerFull">
      <headerbar/>
      <br>
      <budget-viewer :budget="budget" v-show="budget !== null"/>
      <div class="pg-listar-boletos">
          <div class="tabelaPrincipal">
            <div class="opcoesListagemTabela">
              <form action="#" class="formularioSelecao">
                <div class="row">
                  <div class="col-md-4">
                    <label for="qtdVeiculos">Últimos</label>
                    <span class="maskSelect">
                      <select @change="changeOptionPerPage" class="custom" name="qtdVeiculos" id="qtdVeiculos">
                          <option v-for="option in optionsPerPage"
                                  :value="option"
                                  :key="option">{{ option }}</option>
                      </select>
                      
                      <i class="fas fa-sort-down"></i>
                    </span>
                    <label for="qtdVeiculos"> orçamentos</label>
                    <br><i
                    class="fas fa-user-check"
                    title="Orçamentos finalizados e enviados por email"
                    style="color: #4f9a60"></i> Enviados
                    <br><i
                    class="fas fa-exclamation-triangle"
                    title="Orçamentos não finalizados"
                    style="color: #d4d40b"></i> Pendentes
                  </div>
                  <div class="col-md-8">
                    <!-- <div class="camposPesquisa">
                       <label for="buscarVeiculos">Buscar:</label>
                       <input type="text"
                       id="buscarVeiculos"
                       name="q"
                       placeholder="Buscar por nome de serviço">
                       <button type="submit"><i class="fas fa-search"></i></button>
                     </div> -->
                  </div>
                </div>
              </form>
            </div>
            <div class="table-responsive">
              <table class="table">
                <thead>
                <tr>
                  <th scope="col">Status</th>
                  <th scope="col">Data</th>
                  <th scope="col">Cliente</th>
                  <th scope="col">Serviço</th>
                  <th scope="col">E-mail</th>
                  <th scope="col">Telefone</th>
                </tr>
                </thead>
                <tbody>
                <tr
                  ref="budgetDetailsRow"
                  @click="setBudgetViewer(budget, $event)"
                  v-for="budget in budgets" v-bind:key="budget.sessionCode"
                  v-bind:title="dateSinceCreation(budget.created_at)">
                  <td v-html="getBudgetStatus(budget)"></td>
                  <td>{{ budget.created_at | moment("DD/MM/YY") }}</td>
                  <td>{{ budget.username ? budget.username.toUpperCase() : '#' }}</td>
                  <td>{{ budget.service ? budget.service.name : '--' }}</td>
                  <td>{{ budget.email }}</td>
                  <td v-html="isWhatsApp(budget.phone, budget.isWhatsApp)"></td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import Headerbar from '@/components/Nav/Headerbar';
import Toolbar from '@/components/Nav/Toolbar';
import BudgetViewer from '@/components/Dashboard/Budgets/BudgetViewer';

export default {
  name: 'dashboard-budget-list',
  data() {
    return {
      filter: {
        perPage: 50,
        page: 1,
      },
      optionsPerPage: [
        50,
        100,
        200,
        300,
      ],
      budget: null,
    };
  },
  async created() {
    await this.fetchBudgets();
  },
  computed: {
    budgets() {
      return this.$store.state.budget.budgets.data.filter((budget) => {
        const email = budget.email
          .trim()
          .toLowerCase();

        const name = budget.username
          .trim()
          .toLowerCase();

        const options = [
          'teste',
          'test',
          'teste 1',
          'teste 2',
          'HC',
          'hcdesenvolvimentos',
          'hcdesenvolvimento',
          'hcdesenvolvimentos.com.br',
          'admin@audiotext.com.br',
          'hudsoncarolino',
          'dev@hudsoncarolino.com.br',
          'carolinohudson',
          'audiotext.com.br',
          'audiotext',
          'usertest@test.com',
          'fdomingueskt@gmail.com',
        ];

        return options.some((test) => {
          if (email.includes(test) || name.includes(test)) { return true; }
        }) ? null : budget;
      });
    },
  },
  methods: {
    isWhatsApp(phone, isWhatsApp) {
      const logoPath = '/static/resources/images/whatsapp_logo.png';
      const whatsAppImage = `<img src="${logoPath}" style="height: 20px; width: 20px" alt="WhatsApp Logo">`;
      return isWhatsApp ? `${whatsAppImage} ${phone}` : phone;
    },
    async changeOptionPerPage(e) {
      this.filter.perPage = e.target.value;
      await this.fetchBudgets();
    },
    async fetchBudgets() {
      await this.$store.dispatch('budget/fetchBudgets', this.filter);
    },
    perPage() {
      return this.rules.perPage;
    },
    setBudgetViewer(budget, e) {
      this.$refs.budgetDetailsRow.forEach(e => e.style.background = '#fff');
      if (budget.status === 'SENT') {
        e.target.parentNode.style.background = '#e9eaee';
        this.budget = budget;
      } else {
        this.budget = null;
        this.$swal({
          type: 'warning',
          title: 'Oops...',
          text: 'Este formulário possui o status pendente! Você pode entrar em contato com o cliente para saber o motivo...',
          confirmButtonText: 'Ok',
        });
      }
    },
    getBudgetStatus(budget) {
      return budget.status === 'SENT'
        ? '<i class="fas fa-user-check" title="Enviada" style="color: #4f9a60"></i>'
        : '<i class="fas fa-exclamation-triangle" title="Pendente" style="color: #d4d40b"></i>';
    },
  },
  components: {
    Toolbar,
    Headerbar,
    BudgetViewer,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Budgets/List.vue